/*
  Cadi overlay manager (22.10.2026).
  Every automatic overlay (Ring Size Help, Klaviyo RdfSmJ) opens only through here.

  Gate: no automatic overlay opens while another layer is open, while focus is in a
  text field, or on an excluded page. Cooldown: 15s from the moment the gate last
  opened (layer closed / field blurred), kept in sessionStorage across pages.
  At most one automatic overlay per page view. Any storage error = open nothing.

  Click-opened layers, texts and analytics events are untouched.
*/
(function () {
  'use strict';
  if (window.CadiOverlayManager) { return; }

  var CFG = window.CadiOverlayConfig || {};
  var COOLDOWN_MS = 15000;
  var POLL_MS = 250;
  var KLAVIYO_FORM_ID = 'RdfSmJ';
  var OLD_FORM_ID = 'YheqVg';
  var KLAVIYO_DELAY_MS = 35000;
  var KLAVIYO_MIN_PAGE = 2;
  var KLAVIYO_CLOSE_DAYS = 5;
  var IDENTIFY_TIMEOUT_MS = 3000;

  var KEY = {
    gateOpenedAt: 'cadi_om_gate_opened_at', // sessionStorage
    pages: 'cadi_om_pages',                 // sessionStorage
    rshShown: 'cadi_om_rsh_shown',          // sessionStorage, one key for all templates
    klClosedAt: 'cadi_om_kl_closed_at',     // localStorage
    klSubmitted: 'cadi_om_kl_submitted',    // localStorage
    kx: 'cadi_om_kx'                        // localStorage
  };

  var EXCLUDED_PATHS = [
    '/cart',
    '/pages/book-an-appointment',
    '/pages/contact',
    '/products/ring-sizer-with-free-express-shipping'
  ];

  // Body classes set by theme layers (documented in popups-2026-10-22/partA.md).
  var BLOCKING_BODY_CLASSES = [
    'overflow-hidden',                    // modal-dialog (information_popup, question form)
    'page-overlay-cart-on',               // cart drawer
    'menu-open', 'menu-drawer-overlay-on',// mobile nav
    'search-overlay-on',                  // search
    'wt-localization-drawer-overlay-on',  // localization drawer
    'page-overlay-on', 'wt-select-opened',// drawer-select
    'variant-dropdown-page-overlay',      // variant / ring size drawers
    'quick-buy-page-overlay',             // quick buy
    'klaviyo-prevent-body-scrolling'      // any Klaviyo popup
  ];

  var NON_TEXT_INPUT_TYPES = { button: 1, submit: 1, reset: 1, image: 1, hidden: 1 };

  // ---------- storage (every access guarded) ----------
  var storageOk = true;
  function sGet(store, key) {
    try { return window[store].getItem(key); } catch (e) { storageOk = false; return null; }
  }
  function sSet(store, key, value) {
    try { window[store].setItem(key, value); return true; } catch (e) { storageOk = false; return false; }
  }

  var loadedAt = Date.now();
  var shownThisView = null;
  var klaviyoOpen = {};
  var identified = false;
  var identifyCheckDone = false;
  var log = [];

  function note(msg) {
    log.push(((Date.now() - loadedAt) / 1000).toFixed(1) + 's ' + msg);
    if (log.length > 100) { log.shift(); }
  }

  function normPath(p) {
    p = String(p || '').toLowerCase();
    return p.length > 1 ? p.replace(/\/+$/, '') : p;
  }
  function isExcludedPage() {
    var here = normPath(window.location.pathname);
    for (var i = 0; i < EXCLUDED_PATHS.length; i++) {
      var p = EXCLUDED_PATHS[i];
      // Suffix match also covers /collections/<c>/products/<handle> and locale prefixes.
      if (here.slice(-p.length) === p) { return true; }
    }
    return false;
  }

  // ---------- gate ----------
  function focusBlocks() {
    var a = document.activeElement;
    while (a && a.shadowRoot && a.shadowRoot.activeElement) { a = a.shadowRoot.activeElement; }
    if (!a || a === document.body) { return null; }
    var tag = a.tagName;
    if (tag === 'TEXTAREA' || tag === 'SELECT') { return 'focus:' + tag.toLowerCase(); }
    if (tag === 'INPUT' && !NON_TEXT_INPUT_TYPES[(a.type || '').toLowerCase()]) { return 'focus:input'; }
    if (a.isContentEditable) { return 'focus:contenteditable'; }
    return null;
  }

  function openLayer() {
    var b = document.body;
    if (!b) { return 'no-body'; }
    for (var i = 0; i < BLOCKING_BODY_CLASSES.length; i++) {
      if (b.classList.contains(BLOCKING_BODY_CLASSES[i])) { return 'body.' + BLOCKING_BODY_CLASSES[i]; }
    }
    if (document.querySelector('modal-dialog[open]')) { return 'modal-dialog'; }
    if (document.querySelector('#CartDrawer.active, cart-drawer.active, cart-drawer[open]')) { return 'cart-drawer'; }
    if (document.querySelector('#wt-drawer-nav.wt-drawer--open, drawer-nav[open]')) { return 'nav'; }
    if (document.querySelector('.wt-select__drawer--open')) { return 'drawer-select'; }
    if (document.querySelector('shopify-chat[open]')) { return 'inbox'; }
    if (document.querySelector('.rs-popup[id^="rs-popup-"]:not(.rs-popup-hidden)')) { return 'ring-size-help'; }
    for (var id in klaviyoOpen) { if (klaviyoOpen[id]) { return 'klaviyo:' + id; } }
    return null;
  }

  function blocker() { return openLayer() || focusBlocks(); }

  var wasBlocked = false;
  function tickGate() {
    var b = blocker();
    if (b && !wasBlocked) { note('gate closed (' + b + ')'); }
    if (!b && wasBlocked) {
      sSet('sessionStorage', KEY.gateOpenedAt, String(Date.now()));
      note('gate opened, cooldown starts');
    }
    wasBlocked = !!b;
    return b;
  }

  function cooldownLeft() {
    var raw = sGet('sessionStorage', KEY.gateOpenedAt);
    if (!storageOk) { return Infinity; }
    var t = parseInt(raw || '0', 10) || 0;
    return Math.max(0, t + COOLDOWN_MS - Date.now());
  }

  // ---------- automatic overlays ----------
  var candidates = [];

  function register(def) {
    if (!def || !def.id || typeof def.show !== 'function') { return; }
    candidates.push(def);
    // Earliest due first: on a product page Ring Size Help (18s) wins over Klaviyo (35s).
    candidates.sort(function (a, b) { return (a.delayMs || 0) - (b.delayMs || 0); });
    note('registered ' + def.id);
  }

  function tryOpen() {
    var b = tickGate();
    if (shownThisView || !storageOk || isExcludedPage()) { return; }
    if (b || cooldownLeft() > 0) { return; }
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (c.done) { continue; }
      if (Date.now() - loadedAt < (c.delayMs || 0)) { continue; }
      var ok = false;
      try { ok = c.eligible ? c.eligible() : true; } catch (e) { ok = false; }
      if (!storageOk) { return; }
      if (!ok) { continue; }
      c.done = true;
      shownThisView = c.id;
      note('open ' + c.id);
      try { c.show(); } catch (e) { note('show failed ' + c.id); }
      return;
    }
  }

  // Ring Size Help: delay from the section settings, one sessionStorage key for every template.
  function registerRingSizeHelp(opts) {
    register({
      id: 'ring_size_help',
      delayMs: opts.delayMs,
      eligible: function () {
        if (!opts.showOnce) { return true; }
        var v = sGet('sessionStorage', KEY.rshShown);
        return storageOk && !v;
      },
      show: function () {
        if (opts.showOnce && !sSet('sessionStorage', KEY.rshShown, '1')) { return; }
        opts.show();
      }
    });
  }

  // Klaviyo RdfSmJ: all targeting lives here, the form itself is custom-trigger only.
  function oldFormSubmitted() {
    var raw = sGet('localStorage', 'klaviyoOnsite');
    if (!raw) { return false; }
    try {
      var forms = JSON.parse(raw).viewedForms.modal.disabledForms || {};
      var hit = function (id) { return !!(forms[id] && forms[id].successActionTypes && forms[id].successActionTypes.length); };
      return hit(OLD_FORM_ID) || hit(KLAVIYO_FORM_ID);
    } catch (e) { return false; }
  }

  function klaviyoEligible() {
    var pages = parseInt(sGet('sessionStorage', KEY.pages) || '0', 10) || 0;
    if (pages < KLAVIYO_MIN_PAGE) { return false; }
    if (sGet('localStorage', KEY.klSubmitted)) { return false; }
    var closed = parseInt(sGet('localStorage', KEY.klClosedAt) || '0', 10) || 0;
    if (closed && Date.now() - closed < KLAVIYO_CLOSE_DAYS * 86400000) { return false; }
    if (sGet('localStorage', KEY.kx)) { return false; }
    if (CFG.customerLoggedIn) { return false; }
    if (oldFormSubmitted()) { return false; }
    if (!identifyCheckDone || identified) { return false; }
    if (!window._klOnsite || typeof window._klOnsite.openForm !== 'function') { return false; }
    return storageOk;
  }

  function checkIdentified() {
    var finished = false;
    function finish(value, why) {
      if (finished) { return; }
      finished = true;
      identified = value === true;
      identifyCheckDone = true;
      note('identified=' + identified + ' (' + why + ')');
    }
    setTimeout(function () { finish(false, 'timeout ' + IDENTIFY_TIMEOUT_MS + 'ms'); }, IDENTIFY_TIMEOUT_MS);
    var tries = 0;
    (function call() {
      var k = window.klaviyo;
      if (k && typeof k.isIdentified === 'function') {
        try {
          Promise.resolve(k.isIdentified()).then(function (v) {
            if (v === true) { identified = true; note('isIdentified=true (late ok)'); }
            finish(v === true, 'isIdentified');
          }, function () { finish(false, 'isIdentified rejected'); });
        } catch (e) { finish(false, 'isIdentified threw'); }
        return;
      }
      if (++tries < 12) { setTimeout(call, 250); }
    })();
  }

  register({
    id: 'klaviyo_' + KLAVIYO_FORM_ID,
    delayMs: KLAVIYO_DELAY_MS,
    eligible: klaviyoEligible,
    show: function () {
      note('openForm ' + KLAVIYO_FORM_ID);
      window._klOnsite.openForm(KLAVIYO_FORM_ID);
    }
  });

  window.addEventListener('klaviyoForms', function (e) {
    var d = e && e.detail;
    if (!d || !d.formId) { return; }
    if (d.type === 'open') {
      klaviyoOpen[d.formId] = true;
      // A Klaviyo popup opened by Klaviyo itself still uses up this view's automatic overlay.
      if (!shownThisView) { shownThisView = 'klaviyo_' + d.formId; }
    }
    if (d.type === 'close') {
      klaviyoOpen[d.formId] = false;
      if (d.formId === KLAVIYO_FORM_ID) { sSet('localStorage', KEY.klClosedAt, String(Date.now())); }
    }
    if (d.type === 'submit' && d.formId === KLAVIYO_FORM_ID) { sSet('localStorage', KEY.klSubmitted, '1'); }
    note('klaviyoForms ' + d.type + ' ' + d.formId);
  });

  // ---------- page bookkeeping ----------
  (function () {
    var pages = parseInt(sGet('sessionStorage', KEY.pages) || '0', 10) || 0;
    sSet('sessionStorage', KEY.pages, String(pages + 1));
    try {
      if (/(^|[?&])_kx=/.test(window.location.search)) { sSet('localStorage', KEY.kx, '1'); }
    } catch (e) { storageOk = false; }
  })();

  // Inbox chat button hidden while the cart drawer is open.
  (function () {
    try {
      var st = document.createElement('style');
      st.textContent = 'body.page-overlay-cart-on shopify-chat{display:none!important}';
      (document.head || document.documentElement).appendChild(st);
    } catch (e) {}
  })();

  window.CadiOverlayManager = {
    register: register,
    registerRingSizeHelp: registerRingSizeHelp,
    blocker: blocker,
    cooldownLeft: cooldownLeft,
    state: function () {
      return { shownThisView: shownThisView, storageOk: storageOk, identified: identified, identifyCheckDone: identifyCheckDone, excluded: isExcludedPage(), log: log.slice() };
    }
  };

  var queued = window.CadiOverlayQueue || [];
  window.CadiOverlayQueue = { push: function (fn) { try { fn(window.CadiOverlayManager); } catch (e) {} } };
  for (var q = 0; q < queued.length; q++) { window.CadiOverlayQueue.push(queued[q]); }

  checkIdentified();
  document.addEventListener('focusin', tickGate, true);
  document.addEventListener('focusout', function () { setTimeout(tickGate, 0); }, true);
  setInterval(tryOpen, POLL_MS);
})();
